import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=10f60456&scoped=true"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./EmptyPlaceholder.vue?vue&type=style&index=0&id=10f60456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f60456",
  null
  
)

export default component.exports